export interface IAppReportTaskTypeRecordReference {
    name: string;
    chartId: string;
    reportFilter: any;
    generalFilter: any;
}

export class AppReportTaskTypeRecordReference implements IAppReportTaskTypeRecordReference {
    name: string;
    chartId: string;
    reportFilter: any;
    generalFilter: any;

    constructor();
    constructor(obj: IAppReportTaskTypeRecordReference);
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.chartId = obj && obj.chartId || "";
        this.reportFilter = obj && obj.reportFilter || null;
        this.generalFilter = obj && obj.generalFilter || null;
    }
}